const Iubenda = {
  install (_Vue, options) {
    /* eslint-disable-next-line */
    window._iub = window._iub || {}
    /* eslint-disable-next-line */
    _iub.csConfiguration = options
    const iubenda = document.createElement('script')
    iubenda.setAttribute('src', '//cdn.iubenda.com/cs/iubenda_cs.js')
    document.head.appendChild(iubenda)
  }
}
export default Iubenda



// WEBPACK FOOTER //
// ./src/plugins/Iubenda.js